import { render, staticRenderFns } from "./component-b3e55151.vue?vue&type=template&id=2002835d&scoped=true&"
import script from "./component-b3e55151.vue?vue&type=script&lang=js&"
export * from "./component-b3e55151.vue?vue&type=script&lang=js&"
import style0 from "./component-b3e55151.vue?vue&type=style&index=0&id=2002835d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2002835d",
  null
  
)

export default component.exports